import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useConfirmDialogStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      position: 'absolute',
    },
    dialogTitle: {
      fontWeight: 'bold',
    },
    dialogContent: {
      textAlign: 'center',
    },
    dialogAction: {
      justifyContent: 'end',
      margin: theme.spacing(0.5),
      marginTop: 0,
    },
    deleteButton: {
      backgroundColor: '#ff0f0f',
      '&:hover': {
        backgroundColor: '#d40000',
      },
      '&:active': {
        backgroundColor: '#e40000',
      },
    },
  })
);

export default useConfirmDialogStyles;
